(ns ui.blackforest.modal
  "Blackforest PRO ULTRA Modal Dialog"
  (:require [storrito.ui.button :as button]
            [parts.replicant.command :as command]
            [parts.replicant.query :as query]
            [ui.ai.core :as core]
            ))

(def dall-e-query
  {:query/kind :query/dall-e-image-generation})

(defn option
  [{:keys [name description id default]} input]
  [:label.inline-flex.items-center.cursor-pointer
   [:input.form-radio.text-blue-600
    {:type "radio"
     :name input
     :value name
     :checked (when default
                true)
     :on {:input [[:store/assoc-in [:ui/modal :image-generation/data input] id]]}}]
   [:div.flex.flex-col
    [:span.ml-2.font-medium name]
    [:span.ml-2.text-sm.text-gray-500 description]]])

(defn option-field
  [{:keys [title options input]}]
  [:fieldset
   {:aria-label title
    :name input}
   [:div.space-y-5.flex.flex-col
    (map
      (fn [o]
        (option o input))
      options)]])

(defn panel
  [state]
  (let [query-result (query/get-result state dall-e-query)
        price (:price query-result)
        discount (:discount query-result)
        command {:command/kind :command/image-generation-blackforest-ultra-pro
                 :command/data (get-in state [:ui/modal :image-generation/data])}
        command-action [:data/command
                        command
                        {:on-success [[:editor2/add-ai-image {:command command
                                                              :default-height 1920
                                                              :default-width 1080}]
                                      [:store/assoc-in [:editor2 :sidebar-panel] :media]
                                      [:ui/modal-close]]
                         :on-error [[:ui/show-error]]}]]

    (cond (not (:organization/positive-credit-balance? query-result))
          (core/upgrade-panel query-result)

          (command/error? state
                          command)
          (let [error (command/get-latest-error state command)]
            [:div.flex.items-center.w-full.justify-center.flex-col
             [:label.text-gray-800.block.text-base.font-bold.mb-2
              "Getting the following error : "]
             [:p {:class "text-red-500 text-s italic min-h-8"}
              "ERROR : " error]
             [:button.mt-5
              {:on {:click [[:crisp/open-chat]]}
               :type "button"
               :class button/button-secondary-css}
              "Contact Support"]])

          :else
          [:div.flex.items-center.w-full.justify-center.flex-col
           {:replicant/key :ai-panel}
           (when (command/issued? state
                                  command)
             [:div.absolute.flex.items-center.w-full.justify-center.flex-col.h-full.bg-white.opacity-80
              [:div.w-16.h-16.border-4.border-blue-500.border-t-transparent.rounded-full.animate-spin]
              [:span.mt-5
               "Loading ..."]])

           [:div.flex.mb-4.items-center
            [:svg.mr-2
             {:fill "currentColor"
              :fill-rule "evenodd"
              :height "24px"
              :viewBox "0 0 24 24"
              :width "24px"
              :xmlns "http://www.w3.org/2000/svg"}
             [:path {:d "M0 20.683L12.01 2.5 24 20.683h-2.233L12.009 5.878 3.471 18.806h12.122l1.239 1.877H0z"}]
             [:path {:d "M8.069 16.724l2.073-3.115 2.074 3.115H8.069zM18.24 20.683l-5.668-8.707h2.177l5.686 8.707h-2.196zM19.74 11.676l2.13-3.19 2.13 3.19h-4.26z"}]]
            [:h2.text-2xl.font-semibold.text-gray-800
             "Let me turn your imagination into imagery:"]]
           [:p.text-sm.text-gray-500.mb-4
            "Note: NSFW (not safe for work) content is not supported."]

           [:div.md:flex.md:space-x-6.w-full
            [:div.flex-1.mb-4.md:mb-0.flex.items-center.justify-center.flex-col
             [:textarea.border.border-gray-300.rounded.p-3.focus:outline-none.focus:ring.focus:ring-blue-500.focus:border-blue-500.h-52.w-full
              {:placeholder "Describe your idea or scene..."
               :x-ref "prompt"
               :value (get-in state [:ui/modal :image-generation/data :prompt])
               :on {:input [[:store/assoc-in
                             [:ui/modal :image-generation/data :prompt]
                             :event/target.value]]}}]]

            [:div.flex.items-center.w-full.justify-center.flex-col
             {:class "md:w-1/2"}
             [:div.flex.flex-col.space-y-2.pl-2.text-gray-800.w-80

              (option-field {:title "Style"
                             :input :style
                             :options [{:name "Vivid"
                                        :description "Generate more processed, less natural-looking images"
                                        :id :vivid
                                        :default true}
                                       {:name "Natural"
                                        :description "Generate less processed, more natural-looking images"
                                        :id :natural}]})]]]

           [:div.flex.items-center.w-full.justify-center.flex-col
            [:button.mt-5
             {:disabled (nil? (get-in state [:ui/modal :image-generation/data :prompt]))
              :on {:click [command-action]}
              :type "button"
              :class button/button-primary-css}
             "Generate Image"]
            (if discount
              [:div.flex.items-center.gap-2.mt-2
               [:span.text-sm.text-gray-400.line-through
                (str "Cost $" (:original-price discount))]
               [:span.text-sm.font-semibold.text-green-600
                (str "$" (:discounted-price discount))]
               [:span.inline-flex.items-center.rounded-md.bg-green-50.px-2.py-1.text-xs.font-medium.text-green-700.ring-1.ring-inset.ring-green-600
                (str (Math/round (* (:discount-percentage discount) 100)) "% OFF")]]
              [:div.mt-2.text-sm.text-gray-500
               "Cost $" price])]]
      )))

(defn render [state]
  [:div
   (panel state)])

(def modal
  {:modal-id :modals/image-generation-modal-blackforest
   :on-load (fn [_location]
              [[:data/query dall-e-query]])
   :render #'render})
